import { z } from 'zod';
import {
  AgreementBillingType,
  AgreementType,
  AgreementAmountType,
} from 'store/agreements/interfaces';

const schema = z.object({
  position: z.string().min(1, { message: 'errors.field_required' }),
  amount: z.string().min(1, { message: 'errors.field_required' }),
  currency: z.string().min(1, { message: 'errors.field_required' }),
  hoursPerWeek: z.string().min(1, { message: 'errors.field_required' }),
  minutesPerWeek: z.string(),
  jobSizeHours: z.string().min(1, { message: 'errors.field_required' }),
  jobSizeMinutes: z.string(),
  billingType: z.nativeEnum(AgreementBillingType, {
    errorMap: () => ({ message: 'errors.field_required' }),
  }),
  type: z.nativeEnum(AgreementType, {
    errorMap: () => ({ message: 'errors.field_required' }),
  }),
  amountType: z.nativeEnum(AgreementAmountType, {
    errorMap: () => ({ message: 'errors.field_required' }),
  }),
});

export default schema;
